import { AppEnvironment } from "@nuso/portal/environments";
import { defaults } from "./defaults";

export const environment: AppEnvironment = {
  ...defaults,
  production: true,
  envName: 'dev',
  sentry: 'https://4e0ca00371fe47a6a0e87911ff6ac547@o146649.ingest.sentry.io/5851829',
};
